import { render, staticRenderFns } from "./RetailerLogosGridSectionModule.vue?vue&type=template&id=5e72eec6&"
import script from "./RetailerLogosGridSectionModule.vue?vue&type=script&lang=js&"
export * from "./RetailerLogosGridSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports